import en from './en.yaml'
import zh from './zh.yaml'

export const HEALTH_REPORT_NS = 'healthReport'
const translations = { zh, en }

export default translations
